<script>
export default {
  name: 'AdminStatsTable',
  props: {
    loading: Boolean,
    stats: Object
  }
};
</script>

<template>
  <table v-loading="loading" class="table table-stripe">
    <thead>
      <tr>
        <th>Statistic</th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Accounts</td>
        <td>{{ stats ? (stats.accounts.total).toLocaleString('en-US') : 0 }}</td>
      </tr>
      <tr>
        <td>Sites</td>
        <td>{{ stats ? (stats.sites.total).toLocaleString('en-US') : 0 }}</td>
      </tr>
      <tr>
        <td>Pages</td>
        <td>{{ stats ? (stats.pages.total).toLocaleString('en-US') : 0 }}</td>
      </tr>
      <tr>
        <td>Users</td>
        <td>{{ stats ? (stats.users.total).toLocaleString('en-US') : 0 }}</td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

// No styles yet
</style>
